<template>
	<div :class="data.width === ComponentWidthEnum.FULLSCREEN ? 'm-3' : 'container p-lg-0 table-section__fix-width'">
		<h2 class="table-section__title">{{ data.table_name }}</h2>
		<h4 class="table-section__sub-title">{{ data.sub_name }}</h4>
		<div class="w-100 d-flex justify-content-center">
			<table class="table-section">
				<tbody>
					<tr v-for="(row, rowIndex) in data.table" :key="rowIndex">
						<td
								class="table-section__item"
								v-for="(cell, colIndex) in row"
								:key="colIndex"
								:class="{'table-section__last-cell': colIndex === row.length - 1}"
						>
							{{ cell }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ITableBlockComponent} from "@/Shared/Interfaces/ITableBlockComponent";
import {defineProps, PropType} from "vue";
import {ComponentWidthEnum} from "@SharedEnums/ComponentWidthEnum";

defineProps({
	data: {
		type: Object as PropType<ITableBlockComponent>,
		required: true,
	},
});

</script>

<style scoped>
</style>
